<template>
  <div class="card-body">
    <h4 id="header-document" class="card-title card-collapse ">
      <span
        class="pointer"
        @click="
          documentComponentModel.collapseState = !documentComponentModel.collapseState
        "
        >Document</span
      >
      <!-- <span class="f-10 ml-2">Description Lorem Ipsom</span> -->
      <span class="f-10 ml-2">
        <b-icon
          icon="exclamation-circle-fill"
          variant="danger"
          animation="throb"
          font-scale="2"
          v-if="documentComponentModel.validateState == false"
          @click="
            documentComponentModel.collapseState = !documentComponentModel.collapseState
          "
        ></b-icon>
      </span>
      <span class="icon-collapse">
        <!-- <i
          class="mdi mdi-comment-plus-outline text-danger i-add-comment font-size-18 mr-4"
          v-b-tooltip.hover
          title="Add comment"
          @click="addCommentClick"
        ></i> -->
        <button
          class="btn-icon-collapse"
          @click="
            documentComponentModel.collapseState = !documentComponentModel.collapseState
          "
        >
          <template>
            <i
              v-if="documentComponentModel.collapseState"
              class="dripicons-minus"
            />
            <i v-else class="dripicons-plus" />
          </template>
        </button>
      </span>
    </h4>
    <b-collapse
      id="collapse-document"
      v-model="documentComponentModel.collapseState"
      @input="modelChanged"
    >
      <div class="pt-3">
        <div class="row">
          <div class="col-12">
            <div class="border-top pb-4"></div>
            <div class="form-row form-group">
              <div class="col-12">
                <div class="card bg-dark-grey">
                  <div class="card-body f-12">
                    <div>รายละเอียด</div>
                    <ul class="mb-0">
                      <li>วิดีโอต้องขนาดไม่เกิน 35 MB</li>
                      <li>เอกสารขนาดต้องไม่เกิน 35 MB</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row form-group">
              <label class="col-lg-2 col-xl-2 col-form-label"
                >เอกสารเพิ่มเติม</label
              >
              <div class="col">
                <div class="table-responsive">
                  <table
                    class="table align-middle table-nowrap table-hover mb-0"
                  >
                    <thead>
                      <tr>
                        <th scope="col" class="text-left">ชื่อ</th>
                        <th scope="col" class="text-left">แก้ไขเมื่อ</th>
                        <th scope="col" class="text-left">ขนาด</th>
                        <th
                          scope="col"
                          class="text-left"
                          v-if="
                            dataPermissions.find(f => f.name === 'files')
                              .isEditable === true
                          "
                        >
                          <label
                            :for="'upload-file-document'"
                            style="top:10px;right: 5px;"
                            class="btn btn-primary btn-sm absolute "
                            ><i class="bx bx-upload"></i>Upload
                          </label>
                          <input
                            type="file"
                            accept=".jpg, .jpeg, .png, .pdf"
                            @change="importFileDocument($event)"
                            :id="'upload-file-document'"
                            hidden
                          />
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(item, index) in fileDocuments"
                        v-bind:key="index"
                      >
                        <td>
                          <a
                            class="text-dark fw-medium front-wrapper"
                            :href="item.url"
                            target="_blank"
                            ><i
                              class="font-size-16 align-middle me-2"
                              :class="getFileIconCode(item.file.name)"
                            ></i>
                            {{ item.file.name }}</a
                          >
                        </td>
                        <td>{{ FormatDateTime(item.create_on) }}</td>
                        <td>{{ formatBytes(item.file.size, 0) }}</td>
                        <td class="text-right">
                          <a
                            v-if="
                              dataPermissions.find(f => f.name === 'files')
                                .isEditable === true
                            "
                            title="ลบไฟล์เอกสารเพิ่มเติม"
                            class="btn btn-ico text-danger"
                            @click="onDeleteFileClick(item)"
                            ><i class="bx bx-trash"
                          /></a>
                        </td>
                      </tr>
                      <tr v-if="fileDocuments && fileDocuments.length == 0">
                        <td colspan="4" class="text-center">
                          ไม่มีไฟล์เอกสารเพิ่มเติม
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="form-row form-group">
              <label class="col-lg-2 col-xl-2 col-form-label">วิดีโอ</label>
              <div class="col">
                <div class="table-responsive">
                  <table
                    class="table align-middle table-nowrap table-hover mb-0"
                  >
                    <thead>
                      <tr>
                        <th
                          scope="col"
                          class="text-left"
                          style="max-width:200px;"
                        >
                          ชื่อ
                        </th>
                        <th scope="col" class="text-left">แก้ไขเมื่อ</th>
                        <th scope="col" class="text-left">ขนาด</th>
                        <th
                          scope="col"
                          class="text-left"
                          v-if="
                            dataPermissions.find(f => f.name === 'files')
                              .isEditable === true
                          "
                        >
                          <label
                            :for="'upload-file-video'"
                            style="top:10px;right: 5px;"
                            class="btn btn-primary btn-sm absolute "
                            ><i class="bx bx-upload"></i>Upload
                          </label>
                          <input
                            type="file"
                            accept=".mp4"
                            @change="importFileVideo($event)"
                            :id="'upload-file-video'"
                            hidden
                          />
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(item, index) in fileVideos"
                        v-bind:key="index"
                      >
                        <td>
                          <a
                            class="text-dark fw-medium"
                            :href="item.url"
                            target="_blank"
                            ><i
                              class="font-size-16 align-middle me-2"
                              :class="getFileIconCode(item.file.name)"
                            ></i>
                            {{ item.file.name }}</a
                          >
                        </td>
                        <td>{{ FormatDateTime(item.create_on) }}</td>
                        <td>{{ formatBytes(item.file.size, 0) }}</td>
                        <td class="text-right">
                          <a
                            v-if="
                              dataPermissions.find(f => f.name === 'files')
                                .isEditable === true
                            "
                            title="ลบไฟล์วิดีโอ"
                            class="btn btn-ico text-danger"
                            @click="onDeleteFileClick(item)"
                            ><i class="bx bx-trash"
                          /></a>
                        </td>
                      </tr>
                      <tr v-if="fileVideos && fileVideos.length == 0">
                        <td colspan="4" class="text-center">
                          ไม่มีไฟล์วิดีโอ
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12"></div>
        </div>
      </div>
    </b-collapse>
  </div>
</template>
<script>
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import { eventBus } from '@/main.js'
import filecloudService from '@/helpers/service/filecloud-service'
import { FormatDateTime } from '@/helpers/utils/format-date.js'

export default {
  name: 'Document',
  components: {},
  props: {
    value: {
      type: Object,
      default: () => {
        return this.documentComponentModel
      },
    },
    requestDocumentInformation: {
      type: Object,
      default: () => {
        return null
      },
    },
    is_view: {
      type: Boolean,
      default: () => {
        return false
      },
    },
  },
  data() {
    return {
      // model: [
      //   { sequence: 0,  file : { size: 524288, name: 'document.jpeg', type: 'image/jpeg' }, url: 'www.ofm....' },
      //   { sequence: 1,  file : { size: 2097152, name: 'video.mp4', type: 'video/mp4' }, url: 'www.ofm....' },
      // ],
      documentComponentModel: {
        collapseState: false,
        validateState: false,
        isPayloadChanged: false,
        fileDocuments: [],
      },
      isFirstWatchValue: true,
      permissions: [
        {
          name: 'files',
          ruleIDs: ['P1', 'P2', 'P3', 'P6', 'P7', 'P8'],
          isEditable: false,
        },
      ],
      uniqId: '',
      fileDocuments: [],
      fileVideos: [],
    }
  },
  created() {
    eventBus.$on('collapse-document', text => {
      this.documentComponentModel.collapseState = true
    })
  },
  async mounted() {
    this.uniqId = '' + new Date().getTime()
    this.documentComponentModel.validateState = true
  },
  computed: {
    isSubmitAble() {
      // if (
      //   (this.documentComponentModel.model &&
      //     this.documentComponentModel.model.length > 0)
      // ) {
      return true
      // } else {
      //   return false
      // }
    },
    // dropzoneImageOptions() {
    //   return {
    //     url: 'https://httpbin.org/post',
    //     thumbnailWidth: 80,
    //     maxFilesize: 0.5,
    //     acceptedFiles: '.jpeg, .png, .pdf',
    //     addRemoveLinks:
    //       this.dataPermissions.find(f => f.name === 'files').isEditable ===
    //       true,
    //     maxFiles: 4,
    //     clickable:
    //       this.dataPermissions.find(f => f.name === 'files').isEditable ===
    //       true,
    //     init: function() {
    //       this.on('maxfilesexceeded', function(file) {
    //         this.removeFile(file)
    //       })
    //     },
    //   }
    // },
    // dropzoneVdoOptions() {
    //   return {
    //     url: 'https://httpbin.org/post',
    //     thumbnailWidth: 80,
    //     maxFilesize: 25,
    //     acceptedFiles: '.mp4',
    //     maxFiles: 4,
    //     clickable:
    //       this.dataPermissions.find(f => f.name === 'files').isEditable ===
    //       true,
    //     addRemoveLinks:
    //       this.dataPermissions.find(f => f.name === 'files').isEditable ===
    //       true,
    //     init: function() {
    //       this.on('maxfilesexceeded', function(file) {
    //         this.removeFile(file)
    //       })
    //     },
    //   }
    // },
    dataPermissions() {
      let permissions = this.permissions
      if (
        this.requestDocumentInformation !== null &&
        this.requestDocumentInformation !== undefined &&
        this.requestDocumentInformation.approval_documents !== null &&
        this.requestDocumentInformation.approval_documents !== undefined
      ) {
        let ruleEditables = this.requestDocumentInformation.approval_documents
          .filter(f => f.my_process_action.can_edit === true)
          .map(m => m.rule_id)

        permissions
          .filter(f => f.ruleIDs.some(s => ruleEditables.some(r => r === s)))
          .forEach(element => {
            element.isEditable = true
          })
      } else {
        permissions.forEach(element => {
          element.isEditable = this.is_view ? false : true
        })
      }
      return permissions
    },
  },
  watch: {
    value: {
      handler(val) {
        this.documentComponentModel = val
        // if (
        //   this.isFirstWatchValue &&
        //   val.model &&
        //   val.model.length > 0 &&
        //   this.documentComponentModel.formUploadData &&
        //   this.documentComponentModel.formUploadData.length == 0
        // ) {
        //   val.model.forEach(element => {
        //     if (
        //       element.file.type == 'image/jpeg' ||
        //       element.file.type == 'image/jpg' ||
        //       element.file.type == 'image/png' ||
        //       element.file.type == 'application/pdf'
        //     ) {
        //       this.$refs.DropzoneDocument.manuallyAddFile(
        //         element.file,
        //         element.url
        //       )
        //     } else if (element.file.type == 'video/mp4') {
        //       this.$refs.DropzoneVDO.manuallyAddFile(element.file, element.url)
        //     }
        //   })
        //   this.isFirstWatchValue = false
        // }
      },
      deep: true,
    },
    isSubmitAble: {
      handler(val) {
        // if (val) {
        //   this.documentComponentModel.validateState = true
        // } else {
        //   this.documentComponentModel.validateState = false
        // }
        this.modelChanged()
      },
    },
    documentComponentModel: {
      handler(val) {
        this.fileDocuments = val.fileDocuments.filter(
          p => p.document_type === 'Document'
        )
        this.fileVideos = val.fileDocuments.filter(
          p => p.document_type === 'Video'
        )
      },
      deep: true,
    },
  },
  methods: {
    modelChanged() {
      this.documentComponentModel.isPayloadChanged = true
      this.$emit('input', this.documentComponentModel)
    },
    onReset() {},
    addCommentClick() {
      eventBus.$emit('regist_product_comment_click', this.$options.name)
    },
    async uploadImage(file, fileDoctype) {
      var sp = file.name.split('.')
      var extension = `.${sp[sp.length - 1]}`
      var _fname = file.name.replace(extension, '')
      // console.log('_fname', _fname)
      // console.log('extension', extension)
      var fileName = `${this.toSeoUrl(_fname)}${extension}`
      let dataOriginal = new FormData()
      dataOriginal.append('file', file, fileName)
      dataOriginal.append('bucket', `${process.env.VUE_APP_BUCKET_PIM}`)
      dataOriginal.append('path', `tmp/register/other-document/${this.uniqId}`)
      dataOriginal.append('key', fileName)
      dataOriginal.append('content_description', `pim-register-other-document`)
      dataOriginal.append('is_upsert', true)
      let resultUploadOriginal = await filecloudService.uploadImageAsync(
        dataOriginal
      )
      if (resultUploadOriginal.status === 201) {
        if (fileDoctype === 'document') {
          this.documentComponentModel.fileDocuments.push({
            sequence: this.documentComponentModel.fileDocuments.length + 1,
            file: { size: file.size, name: fileName, type: file.type },
            create_on: new Date(),
            flag: 'new',
            document_type: 'Document',
            url: resultUploadOriginal.data.content_url,
            //  cdn_url: resultUploadOriginal.data.content_cdn_url,
          })
        } else if (fileDoctype === 'video') {
          this.documentComponentModel.fileDocuments.push({
            sequence: this.documentComponentModel.fileDocuments.length + 1,
            file: { size: file.size, name: fileName, type: file.type },
            create_on: new Date(),
            flag: 'new',
            document_type: 'Video',
            url: resultUploadOriginal.data.content_url,
            // cdn_url: resultUploadOriginal.data.content_cdn_url,
          })
        }
      } else {
        this.$utils.notificationConfirm('error', 'ไม่สามารถ Upload ไฟล์')
      }
      eventBus.$emit('changeLoadingState', false)
    },
    async importFileDocument(e) {
      var vm = this
      const file = e.target.files[0]
      if (file) {
        if (file.type === 'video/mp4') {
          vm.$utils.notification(
            'error',
            'กรุณาอัพโหลดไฟล์ที่ไม่ใช่วีดีโอ',
            2000
          )
        } else if (file.size > 35000000) {
          vm.$utils.notification('error', 'ขนาดไฟล์ไม่เหมาะสม', 2000)
        } else {
          await this.uploadImage(file, 'document')
        }
        e.target.value = ''
      }
    },
    async importFileVideo(e) {
      var vm = this
      const file = e.target.files[0]
      if (file) {
        if (file.type !== 'video/mp4') {
          vm.$utils.notification('error', 'กรุณาอัพโหลดไฟล์ mp4 เท่านั้น', 2000)
        } else if (file.size > 35000000) {
          vm.$utils.notification('error', 'ขนาดวิดีโอไม่เหมาะสม', 2000)
        } else {
          await this.uploadImage(file, 'video')
        }
        e.target.value = ''
      }
    },
    toSeoUrl(url) {
      // make the url lowercase
      var encodedUrl = url.toString().toLowerCase()

      // replace & with and
      encodedUrl = encodedUrl
        .split(/\&+/) /* eslint-disable-line */
        .join('-and-') /* eslint-disable-line */

      // remove invalid characters
      encodedUrl = encodedUrl
        .split(/[^a-z0-9]/) /* eslint-disable-line */
        .join('-') /* eslint-disable-line */

      // remove duplicates
      encodedUrl = encodedUrl.split(/-+/).join('-') /* eslint-disable-line */

      // trim leading & trailing characters
      encodedUrl = encodedUrl.trim('-')

      return encodedUrl
    },
    getFileIconCode(fileName) {
      if (fileName.includes('.png', fileName.length - 4)) {
        return 'mdi mdi-image text-success'
      } else if (fileName.includes('.jpg', fileName.length - 4)) {
        return 'mdi mdi-image text-muted'
      } else if (fileName.includes('.jpeg', fileName.length - 5)) {
        return 'mdi mdi-image text-primary'
      } else if (fileName.includes('.pdf', fileName.length - 4)) {
        return 'bx bxs-file-pdf text-warn'
      } else if (fileName.includes('.mp4', fileName.length - 4)) {
        return 'bx bxs-videos text-warn'
      }
    },
    formatBytes(bytes, decimals = 2) {
      if (bytes === 0) return '0 Bytes'

      const k = 1024
      const dm = decimals < 0 ? 0 : decimals
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

      const i = Math.floor(Math.log(bytes) / Math.log(k))

      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
    },
    async onDeleteFileClick(item) {
      this.documentComponentModel.fileDocuments.splice(
        this.documentComponentModel.fileDocuments.findIndex(
          element => element.url === item.url
        ),
        1
      )

      if (item.flag === 'new') {
        let resultDelete = await filecloudService.deleteFileByUrl(item.url)
        console.log('resultDelete', resultDelete)
      }
    },
  },
}
</script>
<style>
.is-invalid .multiselect__tags {
  border-color: #f46a6a !important;
}
</style>
